import { features } from "../../../features";
import { moment } from "../../../utils/moment";
export const extractSinglesFromOne = (event)=>{
    var _event_ChildEvents;
    const self = event.Kind == 'single' ? [
        event
    ] : [];
    const children = ((_event_ChildEvents = event.ChildEvents) === null || _event_ChildEvents === void 0 ? void 0 : _event_ChildEvents.map(extractSinglesFromOne)) || [];
    return self.concat(...children);
};
export const extractSingles = (events)=>[].concat(...events.map(extractSinglesFromOne));
export const getDateElements = (event)=>{
    const date = moment(event.Start).calendar();
    const start = new Date(event.Start).toLocaleTimeString('nl');
    const end = new Date(event.End).toLocaleTimeString('nl');
    return {
        date,
        start,
        end
    };
};
export const linkFor = (event)=>{
    const config = features().events;
    if (config == 'off') return null;
    return {
        url: `${config.prefix}/${event.Id}`
    };
};
